import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import Step1Inputs from "../../components/Lifestyle/Step1Inputs";

export default function Step1InputPage({ isValidInputs, handleProceed }) {
    return(
        <Stack spacing={3}>
            <Box sx={{ color: 'var(--pri-purple)' }}>
                <Typography variant="h6" >Did you know?</Typography>
                <Typography variant="subtitle1" >For an average monthly expenditure of about $2,248, you would have an estimated personal carbon footprint of 12.034 tCO<sub>2</sub>e per year.</Typography>
            </Box>
            <Divider />
            <Box>
                <Typography variant="h6" gutterBottom>Your Footprint Profile</Typography>
                <Typography variant="body2" gutterBottom>
                    Welcome! To get an overall picture of your carbon footprint and how you compare against an average individual in Singapore, please provide below your total monthly spending.
                    This will give us a starting point!
                </Typography>
            </Box>
            <Step1Inputs />
            <Button className={`pill_btn ${(!isValidInputs) ? 'Mui-disabled' : 'pri_btn'}`} disabled={!isValidInputs} onClick={handleProceed}>proceed</Button>
        </Stack>
    )
}

